<div *ngIf="!mobile" class="top" [ngStyle]="{ color: secondaryColor, 'background-color': primaryColor }">
  <h1 [ngStyle]="{ color: secondaryColor }" [innerHtml]="data.area.name | safeHTML"></h1>
  <button disableRipple="true" mat-icon-button matTooltip="Close" mat-dialog-close>
    <mat-icon>clear</mat-icon>
  </button>
</div>
<div *ngIf="mobile" class="top">
  <button disableRipple="true" mat-icon-button matTooltip="Close" mat-dialog-close>
    <mat-icon>west</mat-icon>
  </button>
  <h1 [ngStyle]="{ color: secondaryColor }" [innerHtml]="data.area.name | safeHTML"></h1>
</div>
<div class="area">
  <!-- <button class="downloadAll" matTooltip="Download everything at once" *ngIf="data.settings.downloads.length > 0" mat-icon-button (click)="downloadAll()">
    <mat-icon>download</mat-icon>
  </button> -->
  <div class="download card" *ngFor="let download of data.settings.downloads; let i = index;">
    <img [src]="download.previewImgUrl | safe" onerror="this.onerror=null;this.src='../../../../../assets/icons/document_icon.png';"/>
    <div class="placeholder"></div>
    <a [href]="download.link" target="_blank" download>
      <button [ngStyle]="hovered === i ? pressedStyle() : buttonStyle()" (mouseover)="hovered = i" (mouseout)="hovered = -1">{{ download.name }}</button>
    </a>
  </div>
</div>
